export class RiskControl{
    id: number;
    applicableRules: string;
    approvalStatus: string;
    comments: string;
    complianceTopic: string;
    controlIds: string;
    dateCreated: Date |null;
    effectiveDate: Date |null;
    entitiesImpacted: string;
    harmToClient: string;
    harmToFirmsViability: string;
    harmToMarket: string;
    inherentRiskImpact: string;
    inherentRiskLikelihood: string;
    inherentRiskRating: string;
    lastEdited: Date|null;
    residualRiskControlStrength: string;
    residualRiskRating: string;
    residualRiskRationale: string;
    riskAccountabilityOwner: string;
    riskApprover: string;
    riskArea: string;
    riskCategory: string;
    riskDescription: string;
    riskOwner: string;
    riskRef: string;
    riskStatus: string;
    riskTitle: string;
    constructor(

    ){
        this.id=0;
        this.applicableRules="";
        this.approvalStatus="";
        this.comments="";
        this.complianceTopic = "";
        this.controlIds="";
        this.dateCreated = null;
        this.effectiveDate = null;
        this.entitiesImpacted = "";
        this.harmToClient="";
        this.harmToFirmsViability = "";
        this.harmToMarket = "";
        this.lastEdited =null;
        this.inherentRiskImpact = "";
        this.inherentRiskLikelihood = "";
        this.inherentRiskRating = "";
        this.residualRiskControlStrength="";
        this.residualRiskRationale = "";
        this.riskAccountabilityOwner = "";
        this.riskApprover="";
        this.riskArea="";
        this.riskCategory="";
        this.riskDescription = "";
        this.riskOwner = "";
        this.riskRef ="";
        this.riskStatus = "";
        this.riskTitle="";
        this.residualRiskRating = "";
    }
    
}
export interface entitiesImpacted {
    value: string;
    name: string;
    geography: string;
  }
